import { render } from "./InfoView.vue?vue&type=template&id=67fabcac&ts=true"
import script from "./InfoView.vue?vue&type=script&lang=ts"
export * from "./InfoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__